import React from 'react';
import { Img } from 'remotion';
import { LayerWrapper } from './LayerWrapper';
import type { LogoLayer as LogoLayerConfig, UploadedAsset } from '../../types';

interface LogoLayerProps {
  layer: LogoLayerConfig;
  asset?: UploadedAsset;
}

export function LogoLayer({ layer, asset }: LogoLayerProps) {
  if (!asset) return null;

  return (
    <LayerWrapper position={layer.position} animation={layer.animation} opacity={layer.opacity}
      border={layer.border} borderRadius={layer.borderRadius} shadow={layer.shadow}>
      <Img
        src={asset.url}
        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 'inherit' }}
      />
    </LayerWrapper>
  );
}
